<div class="row">
  <div class="col-lg-3">
    <label>{{ channel.name }}</label>
  </div>
  <div class="col-lg-3">
    <form class="row align-items-center" [formGroup]="channelForm">
      <div class="mat-form-field-fluid">
        <mat-slide-toggle
          (change)="updateChannel()"
          class="mr-2"
          formControlName="is_active"
        ></mat-slide-toggle>
      </div>
    </form>
  </div>
  <div class="col-lg-6" [hidden]="level === 'USER'">
    <form class="row align-items-center" [formGroup]="configurableForm">
      <div class="mat-form-field-fluid">
        <mat-checkbox (change)="updateChannel()" formControlName="is_configurable"
          >Configurable
        </mat-checkbox>
      </div>
    </form>
  </div>
</div>
